import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const APP_ENV = process.env.REACT_APP_ENV || 'prod';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, role, status, logout } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-4 border-primary-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Dev environment: only admins
  if (APP_ENV === 'dev' && role !== 'admin') {
    logout();
    return <Navigate to="/login" replace />;
  }

  // Suspended / inactive: force logout
  if (status === 'suspended' || status === 'inactive') {
    logout();
    return <Navigate to="/login" replace />;
  }

  return children;
}
